module.exports = __webpack_public_path__ + "static/media/wedding-rings.036ec4c4.svg";